import { cx } from '@vtex/admin-ui'
import type { MouseEventHandler } from 'react'
import type { DefaultProps } from 'typings'
import { useCollapsibleContext } from './useCollapsible.constate'

type HeaderProps = DefaultProps & {
  className?: string
  onClick?: MouseEventHandler<HTMLDivElement>
}

export function Header(props: HeaderProps) {
  const { children, className, onClick } = props
  const { getToggleProps, visible } = useCollapsibleContext()
  const { onClick: onClickToggle, ...restToggleProps } = getToggleProps()

  const handleClick: MouseEventHandler<HTMLDivElement> = (event) => {
    onClick?.(event)
    onClickToggle?.(event)
  }

  return (
    <div
      {...restToggleProps}
      aria-expanded={visible}
      className={cx(restToggleProps.className ?? '', className ?? '')}
      onClick={handleClick}
    >
      {children}
    </div>
  )
}
